import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';

export default function CaCopy({ readOnly, text, onCopy, onTextChange }) {
  function handleTextChange(e) {
    if (readOnly) return;

    onTextChange(e.target.value);
  }

  return (
    <React.Fragment>
      <div className={`text ${readOnly ? 'property-default-ca' : ''}`}>
        <textarea
          className="form-control"
          readOnly={readOnly}
          style={{ minHeight: '120px' }}
          value={text}
          onChange={handleTextChange}
        />
      </div>
      {!readOnly && (
        <Button className="mt-2" label="Copy default CA" variant="ghost" onClick={onCopy} />
      )}
    </React.Fragment>
  );
}

CaCopy.propTypes = {
  readOnly: PropTypes.bool.isRequired,
  text: PropTypes.string,
  onCopy: PropTypes.func,
  onTextChange: PropTypes.func
};
